import { ecss } from '@signal/theme/emotion'
import { createSelector } from 'reselect'
import {
  maxPageWidthSelector,
  breakpointTabletSelector,
  breakpointMobileLandscapeSelector,
  navigationBarHeightSelector,
  navigationBarHeightTabletSelector,
  navigationBarHeightLandscapeSelector,
  navigationBarOuterHeightSelector,
  navigationBarOuterHeightTabletSelector,
  navigationBarOuterHeightLandscapeSelector,
  getSpacingSelector
} from '../selectors'
export * from './utils'

/**
 * CSS mixins that can be re-used across multiple styled components
 * @typedef {Function} StyledComponentMixin
 * @global
 */

/**
 * Mixin used to prevent margins of a component from collapsing, which can
 * sometimes cause unexpected behavior.
 * @type {StyledComponentMixin}
 */
export const clearfix = ecss`
  &:before {
    content: '';
    display: table;
    clear: both;
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
`

/**
 * Mixin to constrain a component to the max page width of the app and center
 * it (horizontally) on the page.
 * @type {StyledComponentMixin}
 */
export const constrainToMaxPageWidth = ecss`
  width: 100%;
  max-width: ${maxPageWidthSelector}px;
  padding: 0 ${getSpacingSelector(3)}px;
  margin-left: auto;
  margin-right: auto;
`

/**
 * Mixin intended for use in components that need to match the height of the
 * navigation bar.
 * @type {StyledComponentMixin}
 */
export const navigationBarHeight = ecss`
  height: ${navigationBarHeightSelector}px;

  ${breakpointTabletSelector} {
    height: ${navigationBarHeightTabletSelector}px;
  }

  ${breakpointMobileLandscapeSelector} {
    height: ${navigationBarHeightLandscapeSelector}px;
  }

  &&& {
    min-height: initial;
  }
`

const declareTopStyles = top => `
  top: ${top}px;
`
const declareTopStylesWithSafeAreas = top => `
  top: ${top}px;
  /* iOS < 11.2 */
  top: calc(${top}px + constant(safe-area-inset-top));
  /* iOS > 11.2*/
  top: calc(${top}px + env(safe-area-inset-top));
`

export const stickyHeaderTop = ecss`
  ${createSelector(
    navigationBarOuterHeightSelector,
    declareTopStylesWithSafeAreas
  )}

  ${breakpointTabletSelector} {
    ${createSelector(
      navigationBarOuterHeightTabletSelector,
      declareTopStylesWithSafeAreas
    )}
  }

  ${breakpointMobileLandscapeSelector} {
    ${createSelector(
      navigationBarOuterHeightLandscapeSelector,
      declareTopStyles
    )}
  }
`
